import * as Yup from 'yup'
import { PasswordValidation } from '../../utils/Validation'

export const ResetPasswordValidationSchema = Yup.object().shape({
  userName: Yup.string().required(),
  token: Yup.string().required(),
  password: Yup.string().required().matches(PasswordValidation, "Password must be at least 8 characters long, contain a lowercase letter, an uppercase letter, a number and a special character ($@!%*#?&></)(^|)."),
  confirmPassword: Yup.string().required().oneOf([Yup.ref("password"), null], "The entered passwords do not match."),
});